import { Component, OnInit, Output, EventEmitter, Input, DOCUMENT, Inject } from '@angular/core';
import { SuggestionService } from 'src/app/services/suggestion/suggestion.service';
import { EditModeService } from 'src/app/services/edit-mode/edit-mode.service';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';
import { EditDialogService } from 'src/app/services/edit-dialog/edit-dialog.service';
import { SaveDialogService } from 'src/app/services/save-dialog/save-dialog.service';
import { RegisterService } from 'src/app/services/register/register.service';
import { BuilderService } from 'src/app/services/builder/builder.service';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { PageScrollService } from 'ngx-page-scroll-core';
import { AlertListService } from '@xref/ngx';
import { UserSaveSendDialogService } from 'src/app/services/user-save-send-dialog/user-save-send-dialog.service';
import { AuthService } from 'src/app/services/auth/auth.service';


@Component({
  selector: 'xqnr-q-actions',
  templateUrl: './q-actions.component.pug',
  styleUrls: ['./q-actions.component.scss'],
  standalone: false
})
export class QActionsComponent implements OnInit {
  @Input() saving = false;
  @Input() questionnaireHasTitle = true;

  suggestionList = [];

  fa = {
    circleNotch: faCircleNotch
  };

  constructor(
    public suggestions: SuggestionService,
    public editMode: EditModeService,
    private backdrop: BackdropService,
    private editDialog: EditDialogService,
    private saveDialog: SaveDialogService,
    private register: RegisterService,
    private builder: BuilderService,
    private animateScrollService: PageScrollService,
    private alertList: AlertListService,
    private userSaveSendDialog: UserSaveSendDialogService,
    private auth: AuthService,
    @Inject(DOCUMENT) private document: any
  ) { }

  ngOnInit(): void {
    // If user returning from Oauth save action, save automatically
    if (this.builder.getAutoSaveOnOauthReturn())
      this.autoSave();
  }

  handleEdit() {
    this.editDialog.show();
    this.backdrop.show();
  }

  handleSaveErrorNoTitle() {
    this.alertList.append([{ active: true, type: "danger", messageKey: 'builder.questionnaireTitle.error', timeout: 3000 }], true, false);
    this.animateScrollService.scroll({
      document: this.document,
      scrollTarget: '#top',
      duration: 500,
    });
  }

  showSaveSendDialog() {
    this.userSaveSendDialog.show();
    this.backdrop.show();
  }

  showSaveDialog() {
    this.saveDialog.show();
    this.backdrop.show();
  }

  showRegisterDialog() {
    this.register.show();
    this.backdrop.show();
  }

  handleSave() {
    if (this.editMode.inEditMode && !this.saving) {
      // Must have title before saving questionnaire
      if (this.questionnaireHasTitle) {
        // Xref user gets option to save or send, otp user just sends
        if (this.auth.isXrefUser())
          this.showSaveSendDialog();
        else {
          this.showRegisterDialog();
        }

        // Show 'empty title' error
      } else {
        this.handleSaveErrorNoTitle();
      }

      // Not is edit mode, show dialog
    } else {
      this.showSaveDialog();
    }
  }

  autoSave() {
    this.builder.removeAutoSaveOnOauthReturn();
    this.handleSave();
  }
}
